import { appLocalStorage } from '@/app/shared/commonURLs';
let BedManagmentBaseURL = appLocalStorage.BedManagmentURL;

let BedManagmentOdataURL = appLocalStorage.BedManagmentOdataURL;

export class BedMgtURL {
    constructor() {
         
        this.BedManagmentServiceList = BedManagmentURLs();
    }
}

const BedManagmentURL = new BedMgtURL();

export { BedManagmentURL };

function BedManagmentURLs() {

    var services = {};

    services["GetODataClassList"] = {
        Method: 'Get',
        URL: BedManagmentOdataURL + 'SLKP_ClassOData?'
    }

    services["AddAccommodationClass"] = {
        Method: 'POST',
        URL: BedManagmentBaseURL + 'SLKP_Class/InsertNewAccommodationClass'
    }
    
    services["EditAccommodationClass"] = {      
        Method: 'POST',
        URL: BedManagmentBaseURL + 'SLKP_Class/EditAccommodationClassDetails'
    }

    services["DeleteAccommodationClass"] = {
        Method: 'DELETE',
        URL: BedManagmentBaseURL + 'SLKP_Class/DeleteAccommodationClass'
    }

    services["GetAccomodationClassDDL"] = {
        Method: 'Get',
        URL: BedManagmentBaseURL + 'SLKP_Class/GetAccomodationClassDDL',
    }

    services["AddBed"] = {
        Method: 'POST',
        URL: BedManagmentBaseURL + 'LKP_Bed/AddBed'
    }

    services["EditBed"] = {
        Method: 'PUT',
        URL: BedManagmentBaseURL + 'LKP_Bed/EditBed'
    }

    services["DeleteBed"] = {
        Method: 'DELETE',
        URL: BedManagmentBaseURL + 'LKP_Bed/DeleteBed'
    }

    services["GetBedsOData"] = {
        Method: 'Get',
        URL: BedManagmentOdataURL + 'LKP_BedModelOData?',
    }

    services["GetIsNphiesEnabled"] = {
        Method: 'Get',
        URL: BedManagmentBaseURL + 'Configuration/GetIsNphiesEnabled',
    }
    return services
}